<template>
  <div class="admin-container">
    <div @click="backtoListPage()" class="back-button">
      <img src="/images/chinaus/arrow-left.svg" alt="" />
      <div>Back</div>
    </div>

    <div class="admin-header">
      <h1>{{ data.order_code }} Order details</h1>
    </div>
    <div style="padding-top: 0.8rem; padding-bottom: 0.8rem"></div>
    <div style="display: flex; justify-content: space-between">
      <span>Name</span>
      <span style="font-weight: 600">{{ data.name }}</span>
    </div>
    <div class="border-line"></div>
    <div style="display: flex; justify-content: space-between">
      <span>Email</span>
      <span style="font-weight: 600">{{ data.email }}</span>
    </div>
    <div class="border-line"></div>
    <div style="display: flex; justify-content: space-between">
      <span>School</span>
      <span style="font-weight: 600">{{ data.school }}</span>
    </div>
    <div class="border-line"></div>
    <div style="display: flex; justify-content: space-between">
      <span>Order Code</span>
      <span style="font-weight: 600">{{ data.order_code }}</span>
    </div>
    <div class="border-line"></div>
    <div style="display: flex; justify-content: space-between">
      <span>Order Date</span>
      <span style="font-weight: 600">{{ data.order_date }}</span>
    </div>
    <div style="padding-top: 0.8rem; padding-bottom: 0.8rem"></div>

    <TableData
      :headers="headers"
      :items="tableItems"
      :loading="false"
      :total-pages="1"
      :current-page="1"
      :is-action="false"
      :use-api-sort="false"
      :customActions="[]"
      variant="rounded"
    >
      <template #cell-status="{ item, value }">
        <div class="custom-select">
          <select
            :value="value"
            @change="(e) => onStatusSelectChange(item.id, e.target.value)"
            class="color-primary"
          >
            <option value="" disabled>Select Approval Status</option>
            <option value="OPEN">OPEN</option>
            <option value="CONFIRMED">CONFIRMED</option>
          </select>
          <img src="/images/arrow-bottom.svg" class="select-icon" />
        </div>
      </template>
    </TableData>
  </div>
</template>

<script setup>
import { onMounted, ref, computed, inject } from "vue";
import makerCartAdminService from "@/services/makerCartAdminService";
import { useRouter, useRoute } from "vue-router";
import TableData from "@/components/common/TableData.vue";

const route = useRoute();
const router = useRouter();

const data = ref({
  email: "",
  name: "",
  order_code: "",
  order_date: "",
  order_items: [],
  school: "",
});

const notify = inject("notify");

// Table headers and items mapping for details
const headers = ref([
  { text: "Activity Name", value: "activity_name", sortable: false },
  { text: "Grade", value: "grade", sortable: false },
  { text: "Students", value: "number_of_students", sortable: false },
  { text: "Focus", value: "focus", sortable: false },
  { text: "Status", value: "status", sortable: false },
]);

const tableItems = computed(() => {
  return (data.value?.order_items || []).map((item) => ({
    id: item.stem_makercart_id,
    activity_name: item.activity_name || "-",
    grade: item.grade || "-",
    number_of_students: item.number_of_students ?? "-",
    focus: item.focus || "-",
    status: item.status || "-",
  }));
});

// Handle dropdown change
const onStatusSelectChange = async (orderItemId, newStatus) => {
  await changeStatus(data.value.id, orderItemId, newStatus);
  if (route.params.id) {
    await fetchData(route.params.id);
  }
};

const fetchData = async (id) => {
  try {
    const response = await makerCartAdminService.getOrderItems(id);
    if (response.status === 200) {
      data.value = response.data.data;
    }
  } catch (error) {
    console.log(error.message);
  }
};

const changeStatus = async (id, makercartId, status) => {
  try {
    const response = await makerCartAdminService.updateOrderItemStatus(
      id,
      makercartId,
      status
    );
    if (response.status === 200) {
      notify.success("Change Status Success", "Success");
    } else {
      notify.error("Change Status Failed", "Error");
    }
  } catch (error) {
    console.log(error.message);
    notify.error("Change Status Failed", "Error");
  }
};

onMounted(() => {
  if (route.params.id) {
    fetchData(route.params.id);
  }
});

function backtoListPage() {
  router.push({ path: `/admin/maker-cart` });
}
</script>
